import styled from 'styled-components';
import { Row, Col, Input, Button, Typography, Card } from 'antd';

export const Container = styled.div`
	display: flex;
	min-height: 100vh;
	background-color: rgba(248, 248, 248, 1) !important;
`;

export const Content = styled.div`
	flex: 1;
	padding: 40px;
	margin-top: 50px;

	@media (max-width: 576px) {
		padding: 20px;
	}

	@media (max-width: 1024px) {
		padding-top: 80px;
	}

	@media (max-width: 768px) {
		margin-top: 5px;
	}
`;

export const StyledCard = styled.div`
	width: 70%;
	background-color: white;
	border-radius: 8px;
	padding: 30px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);

	.subtitle {
		font-size: 18px;
		margin-bottom: 30px;
	}

	@media (max-width: 576px) {
		width: 100%;
	}
`;

export const FormContent = styled.div`
	width: 100%;
	margin-top: 30px;

	.form-group {
		margin-bottom: 0px;
	}

	.input-row {
		display: flex;
		width: 100%;
		gap: 8px;
		align-items: center;
	}

	.input-wrapper {
		margin-bottom: 16px;

		&:first-child {
			flex: 1;
		}

		&:last-child {
			flex-shrink: 0;
		}

		@media (min-width: 768px) {
			&.left-column {
				padding-right: 12px;
			}
			&.right-column {
				padding-left: 12px;
			}
		}
		@media (max-width: 576px) {
			&.right-column {
				padding-left: 0px;
			}
		}
	}

	.button-container {
		display: flex;
		justify-content: center;
		margin-top: 30px;
	}

	label {
		font-size: 14px;
		font-weight: 600;
		color: #333;
		margin-bottom: 8px;
	}
`;

export const FormLabel = styled.div<{ required?: boolean }>`
	font-size: 14px;
	font-weight: 600;
	color: #333;
	margin-bottom: 8px;

	${(props) =>
		props.required &&
		`
		&::after {
			content: ' *';
			color: #ff4d4f;
			margin-left: 2px;
		}
	`}
`;

export const CodeInput = styled(Input)`
	border-radius: 4px;
	font-size: 14px;
	height: 40px;
	width: 100%;

	@media (max-width: 576px) {
		width: 100%;
	}
`;

export const GenerateButton = styled(Button)`
	background-color: rgba(255, 255, 255, 1);
	color: rgba(38, 38, 38, 1);
	border-color: #d9d9d9;
	white-space: nowrap;
	border-radius: 4px;
	position: relative;
	text-align: center;
	margin-bottom: 0;
	box-shadow: none;
	padding: 0 15px;
	margin-top: 0;
	height: 40px;
	min-width: 150px;
	width: auto;
	top: 3px;

	&:hover {
		border-color: rgba(230, 230, 230, 1);
		color: rgba(38, 38, 38, 1);
		background-color: #d9d9d9;
	}

	&:disabled {
		background-color: #f5f5f5;
		border-color: #d9d9d9;
		color: rgba(0, 0, 0, 0.25);
		cursor: not-allowed;
	}

	&:focus {
		border-color: rgba(230, 230, 230, 1);
		color: rgba(38, 38, 38, 1);
		box-shadow: none;
	}

	@media (max-width: 576px) {
		width: 100px;
		padding: 0 0px;
	}
`;

export const PinInputsWrapper = styled.div`
	width: 100%;
`;

export const PinInputsContainer = styled.div`
	display: flex;
	gap: 8px;
	width: 100%;
`;

export const PinInput = styled(Input)`
	width: 100%;
	max-width: 40px;
	height: 40px;
	text-align: center;
	padding: 0;
	font-size: 17px;
	border-radius: 4px;
	font-weight: 700;
`;

export const PinInputError = styled(PinInput)`
	border-color: #ff4d4f;

	&:hover,
	&:focus {
		border-color: #ff7875;
		box-shadow: 0 0 0 2px rgba(255, 77, 79, 0.2);
	}
`;

export const MessageContainer = styled.div`
	margin-top: 8px;
	min-height: 22px;
`;

export const ErrorMessage = styled.div`
	color: #ff4d4f;
	font-size: 14px;
`;

export const SuccessMessage = styled.div`
	color: #52c41a;
	font-size: 14px;
`;

export const PinInfoMessage = styled.div`
	color: #000000;
	font-size: 14px;
`;

export const TimeoutMessage = styled.div`
	color: #faad14;
	font-size: 14px;
	font-weight: 500;
`;

export const AccessButton = styled(Button)`
	background-color: rgba(0, 47, 187, 1);
	border-radius: 4px;
	margin-top: 30px;
	font-size: 16px;
	min-width: 155px;
	width: auto;
	height: 35px;
	color: #fff;

	text-align: center;

	&:hover {
		background-color: rgb(0, 35, 141);
	}
`;

export const SideMenu = styled.div`
	width: 288px;
	background: linear-gradient(rgba(255, 255, 255, 1), rgba(247, 248, 253, 1)) !important;

	@media (max-width: 1024px) {
		display: none;
	}
`;

export const MenuBar = styled.div`
	justify-content: center;
	align-items: center;
	margin-bottom: 50px;
	padding: 12px 16px;
	background: white;
	position: fixed;
	display: flex;
	z-index: 100;
	height: 60px;
	right: 0;
	left: 0;
	top: 0;

	.ant-image {
		width: 10%;
	}

	@media (max-width: 576px) {
		.ant-image {
			width: 50%;
		}
	}

	@media (max-width: 768px) {
		margin-bottom: 10px;
	}
`;

export const MenuItem = styled.div`
	display: flex;
	align-items: center;
	padding: 12px 16px;
	margin: 0 8px;
	border-radius: 4px;
	background-color: #f0f7ff;
	color: #4361ee;
	font-weight: 500;
	font-size: 14px;
`;

export const TitleWrapper = styled.div`
	width: 100%;
	padding: 24px 0;
	display: flex;
	justify-content: center;
	align-items: center;
	margin-bottom: 24px;
`;

export const Title = styled(Typography.Title)`
	&.ant-typography {
		margin-bottom: 0;
		font-size: 32px;
		font-weight: 600;
	}
`;

export const SurveyTitleWrapper = styled(TitleWrapper)`
	margin-bottom: 10px;
`;

export const SurveyTitle = styled(Title)`
	font-size: 42px;
`;

export const InputRow = styled.div`
	display: flex;
	gap: 8px;
	align-items: center;

	@media (max-width: 576px) {
		display: block;
	}
`;

export const InputWrapperPrimary = styled.div`
	flex: 0.7;
	margin-bottom: 0;
`;

export const AnonymousCol = styled(Col)`
	padding-top: 25px;
`;

export const CenteredCol = styled(Col)`
	display: flex;
	justify-content: center;
`;

export const DashboardRow = styled(Row)`
	margin-left: 0 !important;
	margin-right: 0 !important;
`;

export const DashboardCard = styled(Card)`
	width: 200px;
	height: 200px;
	border-radius: 24px !important;
	padding: 0;
	display: flex;
	flex-direction: column;
	margin-right: 10px !important;

	.ant-card-body {
		flex: 1;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		text-align: center;
		padding: 0;
	}

	@media (max-width: 768px) {
		height: 100px;
		width: 100%;
	}
`;

export const DashboardCardCompleted = styled(DashboardCard)`
	background-color: rgba(240, 240, 240, 1);
`;

export const LoadingContainer = styled.div`
	display: flex;
	justify-content: center;
	padding: 40px 0;
`;

export const ErrorContainer = styled.div`
	text-align: center;
	padding: 20px 0;
`;

export const SurveySectionTitle = styled(Typography.Title)`
	&.ant-typography {
		margin-bottom: 24px;
	}
`;

export const CompletedSurveySectionTitle = styled(Typography.Title)`
	&.ant-typography {
		margin: 32px 0 24px;
	}
`;

export const CardTitle = styled(Typography.Title)`
	&.ant-typography {
		margin: 0 0 12px;
	}
`;

export const CardTitleMobile = styled(Typography.Title)`
	&.ant-typography {
		margin: 0 0 12px;
		text-align: center;
	}
`;

export const CardText = styled(Typography.Text)`
	text-align: center;
	margin: 0;
`;
